const INITIAL_ITEMS = 10;
const BASE_URL = '/api/collections/participant_reviews/entries';

export default (entryId = null, reviewsCount = null, filter = 'course') => ({
  items: [],
  page: 1,

  get loadMoreNumber() {
    if (reviewsCount - (this.items.length + INITIAL_ITEMS) <= 10) {
      return reviewsCount - (this.items.length + INITIAL_ITEMS);
    } else {
      return 10;
    }
  },

  get loadAvaliable() {
    return this.loadMoreNumber > 0;
  },

  loadMore() {
    fetch(
      `${BASE_URL}?sort=-date&filter[${filter}:is]=${entryId}&limit=10&page=${
        this.page + 1
      }`
    )
      .then((response) => response.json())
      .then((response) => {
        this.items = this.items.concat(response.data);
        this.page++;
        this.$nextTick(() => {
          this.resizeAllGridItems();
        });
      });
  },

  formatDate(ogDate) {
    const date = new Date(ogDate);
    return (
      date.getDate() +
      '.' +
      date.getMonth() +
      '.' +
      date.getFullYear().toString().substr(-2)
    );
  },

  resizeGridItem(item) {
    const grid = document.getElementsByClassName('course-references__items')[0];
    const rowHeight = parseInt(
      window.getComputedStyle(grid).getPropertyValue('grid-auto-rows')
    );
    const rowGap = parseInt(
      window.getComputedStyle(grid).getPropertyValue('grid-row-gap')
    );
    const rowSpan = Math.ceil(
      (item.querySelector('.course-reference__wrapper').getBoundingClientRect()
        .height +
        rowGap) /
        (rowHeight + rowGap)
    );
    item.style.gridRowEnd = 'span ' + rowSpan;
  },

  resizeAllGridItems() {
    const allItems = document.getElementsByClassName('course-reference');
    for (let x = 0; x < allItems.length; x++) {
      this.resizeGridItem(allItems[x]);
    }
  },

  init() {
    this.resizeAllGridItems();
  },
});
